exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "md-sidenav-container {\n  height: 100%;\n  background: transparent;\n}\n\nmd-sidenav {\n  width: 410px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = 1940
// module chunks = 0